import React, { useState, useEffect } from "react";
import axios from "axios";
import { getUserDetails } from "../Utility/AsyncStorage";
import { showToast } from './Toast';
import { Tooltip } from 'react-tooltip'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function WorkStation() {
  var userDetails = getUserDetails();

  const [parts, setParts] = useState([]);
  const [formData, setFormData] = useState({});

  const [globalWs, setGlobalWs] = useState(undefined);
  const [isFormVisible, setFormVisible] = useState(false);
  const [isDeleteVisible, setDeleteVisible] = useState(false);
  const [isassignVisible, setAssignVisible] = useState(false);
  const [isAlreadyAssignVisible, setAlreadyAssignVisible] = useState(false);
  const [assginedList, setAssignedList] = useState([]);

  const [machines, setMachines] = useState([]);
  const [selectedMachines, setSelectedMachines] = useState([]);

  const [selectedDevice, setSelectedDevice] = useState("");
  const [optionsForDevice, setdropDownListOfDevice] = useState([]);
  const [productOption, setProductOption] = useState([])


  const [selectedProduct, setSelectedProduct] = useState("");

  // console.log(formData)

  const workStationListData = async () => {
    console.log("workStationListData");
    try {
      let url = process.env.REACT_APP_BASE_URL + "/ws/listOfWs";
      let body = {
        comp_num: userDetails.comp_num,
      };
      console.log("body login", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("workStationListData", response.data.list);
              setParts(response.data.list);
            } else {
              console.log("workStationListData", response.data.msg);
            }
          }
        })
        .catch((error) => {
          console.log("workStationListData", error);
        });
    } catch (error) {
      console.log("workStationListData", error);
    }
  };

  const assignedMachineList = async (ws_num) => {
    console.log("assignedMachineList", ws_num);
    setAssignedList([]);
    try {
      let url = process.env.REACT_APP_BASE_URL + "/ws/wsMachineAssignList";
      let body = {
        comp_num: userDetails.comp_num,
        ws_num
      };
      console.log("body assignedMachineList", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("assignedMachineList", response.data.data);
              setAssignedList(response.data.data);
            } else {
              console.log("assignedMachineList", response.data.msg);
            }
          }
        })
        .catch((error) => {
          console.log("assignedMachineList", error);
        });
    } catch (error) {
      console.log("assignedMachineList", error);
    }
  };

  const listOfDevice = async () => {
    console.log("listOfDevice");
    try {
      let url =
        process.env.REACT_APP_BASE_URL + "/device/companyWiseDeviceList1";
      let body = {
        comp_num: userDetails.comp_num,
      };
      console.log("body listOfDevice", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("listOfDevice", response.data.data);
              setdropDownListOfDevice(response.data.data)
            } else {
              console.log("listOfDevice", response.data.msg);
            }
          }
        })
        .catch((error) => {
          console.log("listOfDevice", error);
        });
    } catch (error) {
      console.log("listOfDevice", error);
    }
  };

  const listOfMachine = async (device_id) => {
    console.log("listOfMachine", device_id);
    setMachines([]);
    try {
      let url = process.env.REACT_APP_BASE_URL + "/sensor/getSensorList";
      let body = {
        comp_num: userDetails.comp_num,
        device_id,
      };
      console.log("body listOfMachine", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("listOfMachine", response.data.result);
              setMachines(response.data.result);
            } else {
              console.log("listOfMachine", response.data.msg);
            }
          }
        })
        .catch((error) => {
          console.log("listOfMachine", error);
        });
    } catch (error) {
      console.log("listOfMachine", error);
    }
  };

  const apiToUnassignMachine = async (machine_id) => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/ws/wsMachineAssignCruds";
      let body = {
        comp_num: userDetails.comp_num,
        ws_num: globalWs,
        is_active: "N",
        machine_id: String(machine_id),
      };
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              assignedMachineList(globalWs);
              setFormVisible(false);
            } else {
              console.log("apiToUnassignWS", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("apiToUnassignWS", error);
        });
    } catch (error) {
      console.log("apiToUnassignWS", error);
    }
    setFormVisible(false);
    setFormData({});
    setGlobalWs(undefined);
  };

  const apiToAssignMachines = async () => {
    if (selectedDevice.length === 0) {
      showToast("Select machines to assign", 3000, "red");
      return
    }
    try {
      let url = process.env.REACT_APP_BASE_URL + "/ws/wsMachineAssignCruds";
      let body = {
        comp_num: userDetails.comp_num,
        ws_num: globalWs,
        device_id: selectedDevice
      };
      console.log("apiToAssignMachines ", body)
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              assignedMachineList(globalWs);
              setFormVisible(false);

            } else {
              console.log("apiToUnassignWS", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("apiToUnassignWS", error);
        });
    } catch (error) {
      console.log("apiToUnassignWS", error);
    }
    setFormVisible(false);
    setAssignVisible(false);
    setFormData({});
    setSelectedDevice([]);
    setSelectedMachines([]);
    setMachines([])
    setGlobalWs(undefined);
  };

  const handleSubmit = async () => {
    if (Object.keys(formData).length === 0) {
      showToast("Provide details first !", 3000, "red");
      return
    }
    try {
      let url = process.env.REACT_APP_BASE_URL + "/ws/addWs";
      let body = {
        comp_num: userDetails.comp_num,
        ws_num: formData.ws_num,
        ws_name: formData.ws_name,
        product_part: formData.product_part,
        estimated_time: formData.estimated_time,
        added_by: userDetails.user_id,
        line_target: formData.line_target
      };
      console.log("body", body)
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              workStationListData();
              setFormVisible(false);
            } else {
              console.log("workStationListData", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("workStationListData", error);
        });
    } catch (error) {
      console.log("workStationListData", error);
    }
    setFormVisible(false);
    setFormData({});
    setSelectedProduct("");
  };

  const handleChange = (fieldName, value) => {

    if (fieldName == "product_part") // Fixed the typo (removed extra space)
    {
      setFormData((prevData) => ({
        ...prevData,
        product_part: productOption[value].part,
        estimated_time: productOption[value].time,
      }));

      setSelectedProduct(value)
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [fieldName]: value,
      }));
    }
  };


  const deleteWorkStation = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/ws/addWs";
      let body = {
        comp_num: userDetails.comp_num,
        ws_num: formData.ws_num,
        added_by: userDetails.user_id,
        is_active: "N",
      };
      console.log("deleteWorkStation ", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              workStationListData();
              setFormVisible(false);
              setDeleteVisible(false);
            } else {
              console.log("deleteWorkStation", response.data.msg);
              setFormVisible(false);
            }
          }
        })
        .catch((error) => {
          console.log("deleteWorkStation", error);
        });
    } catch (error) {
      console.log("deleteWorkStation", error);
    }
    setFormVisible(false);
    setDeleteVisible(false);
    setFormData({});
  };

  const handleDeviceChange = async (event) => {
    const deviceId = event.target.value;
    setSelectedDevice(deviceId);
    setMachines([]); // Reset machines list on device change
    setSelectedMachines([]); // Reset selected machines
    await listOfMachine(deviceId);
  };

  const handleMachinesChange = (event) => {
    const value = event.target.value;
    setSelectedMachines(
      (prevSelected) =>
        prevSelected.includes(value)
          ? prevSelected.filter((item) => item !== value) // Remove if already selected
          : [...prevSelected, value] // Add if not selected
    );
  };

  const productList = async () => {
    console.log("productList");
    try {
      let url = process.env.REACT_APP_BASE_URL + "/ws/listProductPart";
      let body = {
        comp_num: userDetails.comp_num
      };
      console.log("productList ", body);
      await axios
        .post(url, body, {
          headers: {
            authorization: `${userDetails.access_token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("productList", response.data.list);
              setProductOption(response.data.list)
            } else {
              console.log("productList", response.data.msg);

            }
          }
        })
        .catch((error) => {
          console.log("productList", error);
        });
    } catch (error) {
      console.log("productList", error);
    }
  }

  const editCardDetails = (cardData) => {
    console.log(cardData);
    setFormVisible(true);
    setFormData(cardData);
    const foundItem = productOption.findIndex(item => item.part === cardData.product_part);
    setSelectedProduct(foundItem)
  };

  useEffect(() => {
    workStationListData();
    productList();
  }, []);

  return (
    <div className="mainBlock">
      <div className="header">
        <div
          className="inlineHead"
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <h2 className="header-h2">All Work Stations</h2>
          <div
            className="addBlock"
            onClick={() => {
              setFormVisible(true);
            }}
          >
            <h4>Add</h4>
            <i class="fa-solid fa-network-wired"></i>
          </div>

          {/* <div className='downloadBox'>
            <h4>Download</h4>
            <i class="fa-regular fa-circle-down"></i>
          </div>

          <div className="search-bar">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input type="text" placeholder="Search..." className="search-input" />
          </div> */}
        </div>
      </div>

      <table className="workgroup-table">
        <thead>
          <tr
            style={{
              height: "40px",
              backgroundColor: "#f9f9f9",
              textAlign: "left",
            }}
          >
            <th style={{ borderRadius: "10px 0 0 10px", marginLeft: "10px" }}>
              Name
            </th>
            <th>Product Part Name</th>
            <th>Machines</th>
            <th style={{ textAlign: "center" }}>Estimated Time(in sec)</th>
            <th style={{ borderRadius: "0 10px 10px 0", textAlign: "center" }}>
              Action
            </th>
          </tr>
        </thead>
        {Object.keys(parts).length === 0 ?
          <tr>
            {Array.from({ length: 5 }).map((_, index) => (
              <td key={index}>
                <Skeleton count={10} />
              </td>
            ))}
          </tr>
          :
          <tbody>
            {parts.map((item, index) => (
              <tr key={index}>
                <td>{item.ws_name}</td>
                <td>{item.product_part}</td>
                <td>{item.machine_id.length}</td>
                <td style={{ textAlign: "center" }}>{item.estimated_time}</td>
                <td style={{ padding: "8px", textAlign: "center" }}>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Edit"
                    style={{ margin: "5px" }}
                    class="fa-regular fa-pen-to-square"
                    onClick={() => editCardDetails(item)} //edit
                  ></i>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Machine List"
                    style={{ margin: "5px" }}
                    class="fa-solid fa-list"
                    onClick={() => {
                      setAlreadyAssignVisible(true);
                      setGlobalWs(item.ws_num);
                      assignedMachineList(item.ws_num); //To see already machine assigned list
                    }}
                  ></i>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Assign machine"
                    style={{ margin: "5px" }}
                    class="fa-solid fa-right-left"
                    onClick={() => {
                      setAssignVisible(true);
                      setGlobalWs(item.ws_num);
                      listOfDevice();
                    }} //To assign new work station to via dropdown
                  ></i>
                  <i
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Delete"
                    style={{ margin: "5px" }}
                    class="fa-regular fa-trash-can"
                    onClick={() => {
                      setDeleteVisible(true);
                      setFormData({ ws_num: item.ws_num }); //delete work group
                    }}
                  ></i>
                  <Tooltip id="my-tooltip" />
                </td>
              </tr>
            ))}
          </tbody>
        }
      </table>

      {isFormVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>
              {formData.hasOwnProperty("ws_num")
                ? "Edit Work Station"
                : "Add Work Station"}
            </h2>
            <div>
              <div className="input-group">
                <label htmlFor="ws_name">Workstation Name</label>
                <input
                  type="text"
                  id="ws_name"
                  name="ws_name"
                  value={formData.ws_name}
                  onChange={(e) => handleChange("ws_name", e.target.value)}
                />
              </div>
              <div className="input-group">
                <label htmlFor="product_part">Product Part Name</label>
                <select
                  id="product_part"
                  value={selectedProduct}
                  onChange={(e) => handleChange("product_part", e.target.value)}
                  style={{ maxHeight: "200px", height: "fit-content", color: "black" }}
                >
                  <option value="" disabled>
                    -- Select Device --
                  </option>
                  {productOption.map((item, index) => (
                    <option key={item.id} value={index}>
                      {item.part}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group">
                <label htmlFor="estimated_time">
                  Estimantion time(in sec)
                </label>
                <input
                  type="text"
                  id="estimated_time"
                  name="estimated_time"
                  value={formData.estimated_time}
                  onChange={(e) =>
                    handleChange("estimated_time", e.target.value)
                  }
                />
              </div>
              <div className="input-group">
                <label htmlFor="line_target">Workstation target</label>
                <input
                  type="text"
                  id="line_target"
                  name="line_target"
                  value={formData.line_target}
                  onChange={(e) => handleChange("line_target", e.target.value)}
                />
              </div>

              <div style={{ justifyContent: "flex-end" }} className="inline">
                <div
                  className="submit-button"
                  onClick={() => {
                    setFormVisible(false);
                    setFormData({});
                    setSelectedProduct("");
                  }}
                >
                  Back
                </div>
                <div className="submit-button" onClick={handleSubmit}>
                  Submit
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {isassignVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>Assign Machines</h2>
            <label htmlFor="device-select">Select Device</label>
            <select
              id="device-select"
              value={selectedDevice}
              onChange={handleDeviceChange}
              style={{ maxHeight: "200px", height: "fit-content", color: "black" }}
            >
              <option value="" disabled>
                -- Select Device --
              </option>
              {optionsForDevice.map((device) => (
                <option key={device.device_id} value={device.device_id}>
                  {device.device_name}
                </option>
              ))}
            </select>

            {selectedDevice && (
              <div>
                <label htmlFor="machine-select">Select Machines:</label>
                <select
                  id="machine-select"
                  multiple
                  value={selectedMachines}
                  onChange={handleMachinesChange}
                >
                  {machines.map((machine) => (
                    <option key={machine._id} value={machine._id}>
                      {machine.sensor_name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="inline" style={{ justifyContent: "flex-end", alignItems: 'center' }}>
              <div
                className="submit-button"
                onClick={() => {
                  setGlobalWs(undefined);
                  setAssignVisible(false);
                  setFormData({});
                  setSelectedDevice([]);
                  setSelectedMachines([]);
                  setMachines([])
                }}
              >
                Close
              </div>
              <div
                className="submit-button"
                onClick={() => {
                  apiToAssignMachines()
                }}
              >
                Submit
              </div>
            </div>
          </div>
        </div>
      )}

      {isAlreadyAssignVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>Assign Machines List</h2>
            <div className="table-block">
              <table className="work-table">
                <thead style={{
                  borderRadius: "10px", backgroundColor: "#ddd", position: "sticky", top: 0, zIndex: 1, color: "black",
                  fontFamily: "poppins, sarif", fontWeight: "200"
                }}>
                  <tr>
                    <th style={{ padding: "8px", borderRadius: "10px 0 0 10px" }}>
                      Machine Name
                    </th>
                    <th style={{ padding: "8px", borderRadius: "0 10px 10px 0" }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {assginedList.map((item, index) => (
                    <tr key={index}>
                      <td style={{ padding: "8px", color: "black" }}>
                        {item.sensor_name}
                      </td>
                      <td style={{ padding: "8px", color: "black" }}>
                        <i
                          style={{ margin: "5px" }}
                          class="fa-regular fa-trash-can"
                          onClick={() => apiToUnassignMachine(item.machine_id)} //api to unassign ws
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ justifyContent: "flex-end" }} className="inline">
              <div
                className="submit-button"
                onClick={() => {
                  setGlobalWs(undefined);
                  setAlreadyAssignVisible(false);
                  setFormData({});
                }}
              >
                Close
              </div>
            </div>
          </div>
        </div>
      )}

      {isDeleteVisible && (
        <div className="overlay">
          <div className="form-box">
            <h2>Do you want to delete Workstation ? </h2>
            {/* <p>Do you accept?</p> */}
            <hr></hr>
            <div>
              <div style={{ justifyContent: "flex-end" }} className="inline">
                <div
                  className="submit-button"
                  onClick={() => {
                    setDeleteVisible(false);
                    setFormData({});
                  }}
                >
                  No
                </div>
                <div
                  className="submit-button"
                  onClick={() => {
                    deleteWorkStation();
                  }}
                >
                  Yes
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default WorkStation;
